module.exports = __webpack_public_path__ + "images/klockor.6a2e5aa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/klockor.jpg
// module id = d647c5bc
// module chunks = 6 16